<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Emis</h2>
    <v-divider></v-divider>
    <br />

    <v-data-table
      :headers="emiHeaders"
      :items="emiList"
      :hide-actions="true"
      class="elevation-1"
      :loading="loading"
      :expand="expand"
    >
      <template v-slot:items="props">
        <td>
          <v-icon
            @click="props.expanded = !props.expanded"
            v-if="props.item.transactions && props.item.transactions.length"
          >
            <template v-if="props.expanded">keyboard_arrow_up</template>
            <template v-else>keyboard_arrow_down</template>
          </v-icon>
        </td>
        <td>
          {{ props.item.transaction_title }}
        </td>
        <td class="text-xs-right">{{ props.item.id }}</td>
        <td class="text-xs-right">
          {{ props.item.monthly_payable }}
        </td>
        <td class="text-xs-right">
          {{ props.item.due_amount }}
        </td>
        <td class="text-xs-center">
          {{ props.item.payment_end_date }}
        </td>
        <td class="text-xs-center">
          <h4>{{ emiStatus(props.item.emi_status_id) }}</h4>
        </td>
        <td class="text-xs-center">
          {{ props.item.emi_to_pay >= 0 ? props.item.emi_to_pay : "not done" }}
        </td>
        <td class="text-xs-right">
          {{
            props.item.amount_to_pay >= 0
              ? props.item.amount_to_pay
              : "not done"
          }}
        </td>
        <!-- <td class="text-xs-center">
          {{
            props.item.transactions.length && !props.item.is_partial
              ? props.item.transactions[0].tran_date
              : "-"
          }}
        </td> -->
      </template>
      <template v-slot:expand="props">
        <template>
          <v-data-table
            :headers="transactionHeaders"
            :items="props.item.transactions"
            class="elevation-1 ma-2"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-right">{{ props.item.id }}</td>
              <td class="text-xs-center">
                {{ props.item.tran_type == "7" ? "Parital" : "Full" }}
              </td>
              <td class="text-xs-center">{{ props.item.tran_id }}</td>
              <td class="text-xs-center">{{ props.item.tran_title }}</td>
              <td class="text-xs-right">{{ props.item.tran_amount }}</td>
              <td class="text-xs-center">{{ props.item.tran_date }}</td>
            </template>
          </v-data-table>
        </template>
      </template>
    </v-data-table>
  </v-list>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import { fundingEMIList } from "@/utils/variables";
  export default {
    props: ["emis", "fundingId"],
    data() {
      return {
        emiHeaders: [
          { text: "", value: "expand", align: "left", sortable: false },
          { text: "Serial No.", value: "transaction_title", align: "left" },
          { text: "ID", value: "id", align: "right" },
          { text: "Monthly Payable", value: "monthly_payable", align: "right" },
          { text: "Due Amount", value: "due_amount", align: "right" },
          { text: "Due Date", value: "payment_end_date", align: "center" },
          { text: "EMI Status", value: "emi_status_id", align: "center" },
          { text: "EMI To Pay", value: "emi_to_pay", align: "center" },
          { text: "Amount To Pay", value: "amount_to_pay", align: "right" },
          // { text: "Payment Date", value: "paymentDate", align: "center" },
        ],
        emiList: [],
        loading: true,
        expand: false,

        transactionHeaders: [
          {
            text: "ID",
            value: "id",
            align: "right",
          },
          { text: "Tx. Type", value: "tran_type", align: "center" },
          { text: "Tx. ID", value: "tran_id", align: "center" },
          { text: "Tx. Title", value: "tran_title", align: "center" },
          { text: "Amount", value: "tran_amount", align: "right" },
          { text: "Tx. Date", value: "tran_date", align: "center" },
        ],
      };
    },
    async mounted() {
      await this.getEMIList();
    },
    methods: {
      async getEMIList() {
        try {
          const { data } = await HTTP().get(
            `${fundingEMIList}/${this.fundingId}`
          );
          // console.log(data.data);
          this.emiList = data.data;
        } finally {
          this.loading = false;
        }
      },

      emiStatus(id) {
        if (id == 1) {
          return "Not Paid";
        } else if (id == 2) {
          return "Paid";
        } else if (id == 3) {
          return "Paid Overdue (1-30D)";
        } else if (id == 4) {
          return "Overdue 1-30D";
        } else if (id == 5) {
          return "Overdue 31-60D";
        } else if (id == 6) {
          return "Overdue 61-90D";
        } else if (id == 7) {
          return "Overdue 90D+";
        } else if (id == 8) {
          return "Current";
        } else if (id == 9) {
          return "Defaulted";
        } else if (id == 10) {
          return "Partially Paid";
        } else if (id == 11) {
          return "PAID overdue (31-60D)";
        } else if (id == 12) {
          return "PAID overdue (61-90D)";
        } else if (id == 13) {
          return "PAID overdue (90D+)";
        } else if (id == 14) {
          return "Paid being defaulted";
        }
      },
    },
  };
</script>
